export default function PHP_Math() {
  return (
    <div>
      <h1>PHP_Math</h1>
    </div>
  );
}
